import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiClientSelect, UiDatePicker, BgLoader, InLoader, UiSeriesSelect, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';

import { Table } from 'antd';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import {MdOutlineMoreVert} from "react-icons/md";


export default function Payments() {
  const pagetype = "payments";
  const [fy] = useOutletContext();
  let navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [pagenum, setPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);
  const [initialLoad, setInitLoad] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: getStorage('perpage') ? [20, 50, 100, 500].includes(parseInt(getStorage('perpage'))) ? parseInt(getStorage('perpage')) : 20 : 20,
      showSizeChanger: true,
      pageSizeOptions: [20, 50, 100, 500],
    },

  });


  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])
    setPage(1)
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, pagetype, 1), { replace: location.search ? true : false })


  };



  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .get("/delete_voucher?type=Payment&id=" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.data.status == 'success') {
          queryClient.invalidateQueries([pagetype])
          clearSelection()
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }


      })



  }



  const headers = [
    { label: "Number", key: "num" },
    { label: "Date", key: "date" },
    { label: "Series", key: "series_name" },
    
    { label: "Party", key: "party" },
    { label: "Amount", key: "amount" },
    { label: "Narration", key: "narration" },
  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {
    let currentUrlParams = new URLSearchParams(filter);
    currentUrlParams.set('type', 'Payment');
    const { data } = await instance.get(
      "/vouchers?" + currentUrlParams
    );

    var dataa = data;
    return dataa;
  }

  const defaultValues = {
    search: null,
    staff: null,
    from: null,
    to: null,
    series: null,
    party: null,
  };


  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      disabled: e.can_edit == 1 ? false : true,
       onClick: () => addVoucher(e.id)
    },
    {
      key: '2',
      disabled: e.can_delete == 1 ? false : true,
      label: (
        <Popconfirm
              title="Delete?"
              description="Are you sure to delete this?"
              onConfirm={() => handleDelete(e.id)}
              okText="Yes"
              cancelText="No"
            >
          <span>Delete</span>
        </Popconfirm>
      ),
    },
    
    
  ];



  const clearFilter = () => {
    setSelectedRowKeys([])
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    reset(defaultValues)
    navigate(updateFilterUrl({}, pagetype, 1), { replace: true })
  }


  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
      //setPage(parseInt(parsed.page))
    } else {
      setPage(1)
      setFilter(defaultValues)
    }



  }, [location]);

  const jvModal = useModal('journal_voucher');

  const addVoucher = (id, row) => {
    jvModal.show({ id: id, type: 'Payment', data: row }).then((res) => {
      queryClient.invalidateQueries([pagetype])
    });


  }

  useEffect(() => {


    const parsed = queryString.parse(location.search);

    if (parsed.page) {
      setPage(parseInt(parsed.page))
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: parseInt(parsed.page),
        },
      });
    } else {
      // setPage(1)
    }

    setFilter(parsed)




  }, []);

  const pdf_columns = [
    {
      title: 'Number',
      dataIndex: 'num',
      key: 'num',
      width:18,
      colspan: 3
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width:23
    },
     
    {
      title: 'Party',
      dataIndex: 'particular',
      key: 'particular',
      items:1,
      width: 65
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      width: 25
    },
    {
      title: 'Narration',
      dataIndex: 'narration', 
      key: 'narration',
      width: 51
    }

  ];


  const columns = [
    {
      title: 'No.',
      width: '50px',
      dataIndex: 'num',
      sorter: 'num',
      sortOrder: parsed.sort_by == 'num' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'num' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Date',
      width: '100px',
      dataIndex: 'date',
      sorter: 'date',
      sortOrder: parsed.sort_by == 'date' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'date' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Series',
      width: '100px',
      dataIndex: 'series_name',
      sorter: 'series_name',
      sortOrder: parsed.sort_by == 'series_name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'series_name' && parsed.sort == 'desc' ? 'descend' : '',
    },
    

    {
      title: 'Party',
      width: '200px',
      dataIndex: 'party',
      sorter: 'party',
      sortOrder: parsed.sort_by == 'party' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'party' && parsed.sort == 'desc' ? 'descend' : '',
    },

    {
      title: 'Amount',
      width: '100px',
      dataIndex: 'amount',
      sorter: 'amount',
      align: 'right',
      sortOrder: parsed.sort_by == 'amount' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'amount' && parsed.sort == 'desc' ? 'descend' : '',
    },

    {
      title: 'Narration',
      dataIndex: 'narration',
      width: '200px',
      render: (text, row) => (
        <span className="truncate" title={text}>{text}</span>
      )
    },

    {
      title: '',
      fixed: 'right',
      width: '40px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
        items: items(row),
      }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>

       
          </Dropdown>
         
        </div>


      )
    },

  ];


  useEffect(() => {

    var set_perpage = 0;
    if (location.search) {
      const parsed = queryString.parse(location.search);
      if (parsed.perpage) {
        if ([20, 50, 100, 500].includes(parseInt(parsed.perpage))) {
          setInitLoad(true)
        } else {
          setStorage('perpage', 20)
          set_perpage = 1;
        }

      } else {
        set_perpage = 1;
      }

    } else {
      set_perpage = 1;
    }

    if (set_perpage == 1) {


      navigate(updateFilterUrl(window.location.search, pagetype, 1), { replace: true })
    }

  }, [location.search]);

  const { data, error, isError, isLoading, isFetching } = useQuery([pagetype, location.search], () => fetchData(location.search), {
    keepPreviousData: true,
    enabled: initialLoad
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        search: filter.search,
        from: filter.from,
        to: filter.to,
        party: filter.party && parseInt(filter.party),
        staff: filter.staff && parseInt(filter.staff),
        series: filter.series && parseInt(filter.series)

      };
      reset(defaultValues1)
    }
  }, [filter]);

  useEffect(() => {
    queryClient.invalidateQueries(['payments'])
  }, [fy]);


  useEffect(() => {
    if (data) {
      const parsed = queryString.parse(location.search);
      var setpage = 1;
      if (parsed.page) {
        setpage = parseInt(parsed.page);
      }
      if (parsed.page && parseInt(parsed.page) > 1 && data.items.length == 0) {
        let currentUrlParams = new URLSearchParams(window.location.search);

        setpage = Math.ceil(data.total / parseInt(tableParams.pagination.pageSize));
        setPage(setpage)

        currentUrlParams.set('page', setpage);

        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });

        navigate('/' + pagetype + '?' + currentUrlParams.toString(), { replace: true })
      } else {
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });
      }
    }

  }, [data]);




  const expandedRowRender = (row) => {
    const columns = [
      {
        title: 'Account',
        dataIndex: 'name',
        key: 'name',

      },
      {
        title: 'Debit',
        dataIndex: 'debit',
        key: 'debit',
        align: 'right',
        render: (text) => rupees(text),
      },

      {
        title: 'Credit',
        dataIndex: 'credit',
        key: 'credit',
        align: 'right',
        render: (text) => rupees(text),
      },

      {
        title: 'Narration',
        dataIndex: 'narration',
        key: 'narration',
      },
    ];

    return <Table columns={columns} dataSource={row.entries} pagination={false} />;
  };



  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }
    var pg = pagination.current
    setPage(pg)
    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }

    currentUrlParams.set('page', pg);
    var perpage = pagination.pageSize
    currentUrlParams.set('perpage', perpage);
    setStorage('perpage', perpage)
    if (location.search) {
      navigate('/' + pagetype + '?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/' + pagetype + '?' + currentUrlParams.toString())
    }

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });


  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };

  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
        Payments
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Payments" >

            {data.items &&
              <>
                <ExportPDFButton columns={pdf_columns} data={data.items_export} lastbold={true} title="payments" company={data.company} company_desc={data.company_desc} heading1="Payments"/>
                <CSVLink data={data.items_export} filename={"Payments.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }
            <UiButton className="btn btn-primary" onClick={() => addVoucher('new')} title="Add" icon="add" disabled={data.access.add == 0 ? true : false}></UiButton>


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">





                  <div className="col-md-2">

                    <Controller

                      name="from"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          label="From"
                          onChange={onChange}
                          default_val={value}
                          message={errors.from?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>
                  <div className="col-md-2">

                    <Controller

                      name="to"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          label="To"
                          onChange={onChange}
                          default_val={value}
                          message={errors.to?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">
                    <UiInput
                      label="Search"
                      type="text"

                      name="search"

                      {...register("search")}
                    />
                  </div>

                  <div className="col-md-2">
                    <Controller
                      name={`series`}
                      control={control}
                      render={({ field }) => (

                        <UiSeriesSelect
                          {...field}
                          className=""
                          type="Payment"
                          fetch_onload
                          message={errors.series?.message}
                          label="Series"

                        />

                      )}
                    />
                  </div>

                  <div className="col-md-2">
                    <Controller
                      name={`party`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          category={[1,22,23]}
                          className=""
                          fetch_onload
                          message={errors.party?.message}
                          label="Party"

                        />

                      )}
                    />
                  </div>

                  <div className="col-md-2">
                    <Controller
                      name={`staff`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          category={[26]}
                          className=""
                          fetch_onload
                          message={errors.staff?.message}
                          label="Staff"

                        />

                      )}
                    />
                  </div>






                  <div className="col-md-10"></div>


                  <div className="col-md-2">
                    <div className="d-flex justify-content-end">

                      <UiButton type="" className="ms-2 btn-light" title="Clear" onClick={() => clearFilter()} />
                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>
            <div style={{ height: '34px' }} className="ps-3">
              {selectedRowKeys && selectedRowKeys.length > 0 && (
                <div className="bulkaction">
                  <div>
                    <Popconfirm
                      title="Delete?"
                      description="Are you sure to delete this?"
                      onConfirm={() => handleDelete(selectedRowKeys)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <button className="btn btn-outline-danger btn-sm me-2" disabled={data.access.delete ? false : true}  >Delete</button>
                    </Popconfirm>
                    <button className="btn btn-light btn-sm me-2" onClick={() => clearSelection()}>Clear Selection <div className="badge bg-primary">{selectedRowKeys.length}</div></button>

                  </div>
                </div>
              )}
            </div>



            <Table
              id="report"
              locale={{
                emptyText: (<TableZero title="Payment" />)
              }}
              expandable={{
                expandedRowRender,
                defaultExpandedRowKeys: ['0'],
              }}
              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={{ ...tableParams.pagination, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` }}
              loading={{ spinning: (tableDisable || isFetching) }}
              rowSelection={rowSelection}
              onChange={handleTableChange}
              scroll={{
                x: 960,

              }}
              footer={() => (
                <div className="d-flex justify-content-end">
                  <strong className="me-2">Total Amount: </strong>{data.total_amount}
                </div>
              )}
            />

          </div>
        </div>
      </div>
    </>
  );
}
